import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";
import React, { useState } from "react";

function SearchBox({
  setSearchText,
  fetchData,
  consultantDataCount,
  setCurrent
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [typingTimeout, setTypingTimeout] = useState(0);

  const handleChange = (e) => {
    const searchText = e.target.value;
    setSearchText(searchText);
    setSearchTerm(searchText);
    setCurrent(1);

    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    setTypingTimeout(
      setTimeout(() => {
        if (searchText === "" || searchText.length >= 3) {
          fetchData(searchText);
          consultantDataCount(searchText);
        }
      }, 500)
    );
  };

  return (
    <div>
      {/* <input
        type="text"
        placeholder="Search..."
        value={searchTerm}
        onChange={handleChange}
        style={{
          padding: "4px 10px",
          fontSize: "16px",
          borderRadius: "5px",
          border: "1px solid #ccc",
        }}
      /> */}
      <Input
        placeholder="Search..."
        value={searchTerm}
        onChange={handleChange}
        prefix={<SearchOutlined />}
      />
    </div>
  );
}

export default SearchBox;
